import { GenericAbortSignal } from "axios";
import { AutoCompleteDataModel, AutoCompleteSuggestions, MprcAutoComplete } from "components/MprcAutoComplete";
import { IAutoCompleteProps } from "components/MprcAutoComplete/AutoComplete";
import { isCanceledError, useCoreApi } from "providers/CoreApiProvider";

////////////////////////////////////////////////////////////////////////////

type IProps = Omit<IAutoCompleteProps, 'onGetSuggestions' | 'emptyThumbnail'>;

////////////////////////////////////////////////////////////////////////////

/**
 * Auto complete de papeis para cadastros
 * @param props
 */
export const PermissionsAutoComplete: React.FC<IProps> = (props) => {

    const api = useCoreApi();

    const { onError } = props;

    ///
    const getSuggestions = (searchText: string, pageNumber: number, pageSize: number, trySelectedHistory: boolean, signal: GenericAbortSignal | undefined): Promise<AutoCompleteSuggestions<AutoCompleteDataModel>> => {
        searchText = searchText.toLowerCase();

        return new Promise<AutoCompleteSuggestions<AutoCompleteDataModel>>((resolve) => {
            api.v1.suggestions.permissions({
                searchText: searchText,
                pageNumber: pageNumber,
                pageSize: pageSize,
                category: null
            }, { signal })
            .then(result => resolve({
                items: result.data.items as AutoCompleteDataModel[],
                totalRows: result.data.totalRows
            }))
            .catch(error => {
                if (!isCanceledError(error)) {
                    resolve({ items: [], totalRows: 0 });
                    onError && onError(error);
                }
            });
        });
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <MprcAutoComplete
            {...props}
            label=""
            onGetSuggestions={getSuggestions}
        />
    );
};
